import { StatusBadge } from '@/components/common';
import { type StatusBadgeColors } from '@/components/common/StatusBadge/StatusBadge';
import { type ProductDocumentLinkDTO } from '@/domain/products/types';
import { Typography } from '@andritzot/metris-web-ui/data-display/typography';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import { DataGrid, type GridColDef } from '@andritzot/metris-web-ui/mui-x/data-grid';
import { InsertDriveFileOutlined } from '@mui/icons-material';

interface DocumentsTabProps {
  documents: ProductDocumentLinkDTO[];
}

const getColor = (id: number): StatusBadgeColors => {
  switch (id) {
    case 1:
      return 'blue';
    case 2:
      return 'lightBlue';
    case 3:
      return 'lightRed';
    case 4:
      return 'lightGreen';
    case 5:
      return 'green';
    case 6:
      return 'red';
    case 7:
      return 'lightyellow';
    case 8:
      return 'lightGreen';
    case 9:
      return 'yellow';
    case 10:
      return 'green';
    case 11:
      return 'blue';
    case 12:
      return 'lightBlue';
    default:
      return 'blue';
  }
};

const sxRow = { margin: '1rem', display: 'flex', width: '100%' };
const sxIcon = { margin: '0 1rem', display: 'flex', alignItems: 'center' };

const documentTemplate = (document: ProductDocumentLinkDTO) => (
  <Box sx={sxRow}>
    <Box sx={sxIcon}>
      <InsertDriveFileOutlined />
    </Box>
    <Box>
      <StatusBadge color={getColor(document.documentType?.idProductDocumentType ?? 0)} fontSize={10}>
        {document.documentType?.name}
      </StatusBadge>
      <Typography variant="h5" component="p" color="text.secondary">
        <Box component="a" href={document.documentLink} target="_blank" rel="noreferrer">
          {document.documentName}
        </Box>
      </Typography>
    </Box>
  </Box>
);

const columns: GridColDef<ProductDocumentLinkDTO>[] = [
  { field: 'documentName', headerName: '', flex: 1, renderCell: (params) => documentTemplate(params.row) },
];

const getRowId = (row: ProductDocumentLinkDTO) => row.idProductDocumentLink;
const getRowHeight = () => 'auto' as const;

const DocumentsTab = ({ documents }: DocumentsTabProps) => (
  <DataGrid
    rows={documents}
    columns={columns}
    getRowId={getRowId}
    density="compact"
    getRowHeight={getRowHeight}
    pagination
    pageSizeOptions={[5, 10, 20]}
  />
);

export default DocumentsTab;
